import { order, } from '@zurich/api/party';
export const initialState = {
    currentRuleIndex: null,
    context: {},
    rules: null,
    finished: false,
};
export const partyChangedReducer = (state, action) => {
    switch (action.type) {
        case 'SET_CHANGED_RULES': {
            return {
                ...state,
                rules: action.changedRules,
                currentRuleIndex: getNextRuleIndex(null, action.changedRules),
            };
        }
        case 'CONTINUE': {
            const nextRuleIndex = getNextRuleIndex(state.currentRuleIndex, state.rules);
            if (nextRuleIndex !== null) {
                return {
                    ...state,
                    currentRuleIndex: nextRuleIndex,
                    context: {
                        ...state.context,
                        ...action?.context,
                    },
                };
            }
            return { ...initialState, finished: true };
        }
        case 'FINISHED': {
            return initialState;
        }
        default: {
            // throw new Error('Unknown action type');
            return state;
        }
    }
};
export const getNextRuleIndex = (currentRule, changedRules) => {
    const currentRuleIndex = currentRule ? order.indexOf(currentRule) : -1;
    for (let i = currentRuleIndex + 1; i < order.length; i++) {
        if (changedRules?.[order[i]]) {
            return order[i];
        }
    }
    return null;
};
